import { IAction, IAnyValueAction } from "../../../redux/actions";
import { ITheme } from "./Theme";

export enum types {
  RESET_THEME = "RESET_THEME",
  SET_THEME = "SET_THEME"
}

export const resetTheme = (): IAction => {
  return {
    type: types.RESET_THEME
  };
};
export const setTheme = (value: ITheme): IAnyValueAction => {
  return {
    type: types.SET_THEME,
    value
  };
};
